import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import moment from 'jalali-moment'
import { ENC1 } from "../helpers/mmg";
import { updateUserURL } from "../api";

// initial state
export const initialState = {
  loading: false,
  roles : ['Optician','Personnel','FinancialPersonnel'],
  boxMessage : '',
  boxType : 0,//1 Error , 2 Success, 3 Info
  error: false,
  newPass : "",
  oldPass : "",
  reNewPass : ""
};

// our slice
const changePassSlice = createSlice({
  name: "changePass",
  initialState,
  reducers: {
    setChangePassLoading: (state) => {
      state.loading = true;
    },
    setChangePassLoadingFalse: (state) => {
      state.loading = false;
    },
    setChangePassData: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      state.newPass = payload.NewPass;
      state.oldPass = payload.OldPass;
      state.reNewPass = payload.ReNewPass;
      state.hasMore = false;
    },
    setChangePassError: (state) => {
      state.error = true;
      state.loading = false;
    },
    setChangePassResultBox: (state, { payload }) => {

      console.log("setSTOrderResultBox");
      console.log(payload);
      state.boxMessage = payload.message;
      state.boxType = payload.type;//1 Error , 2 Success, 3 Info
    },
    resetChangePassResultBox: (state, { payload }) => {
      state.boxMessage = ''
      state.boxType = 0;//1 Error , 2 Success, 3 Info
    },
    clearChangePass: (state) => {
      state.loading = false;
      state.error = false;
      state.newPass = "";
      state.oldPass = "";
      state.reNewPass = "";
      state.boxMessage = '';
      state.boxType = 0;//1 Error , 2 Success, 3 Info
      state.currentPageIndex = 0;
    },
  },
});

// export the actions
export const { setChangePassLoading, 
  setChangePassData,
  setChangePassError,
  clearChangePass,setChangePassLoadingFalse,setChangePassResultBox,resetChangePassResultBox
} = changePassSlice.actions;


// export the default reducer
export default changePassSlice.reducer;


export function submitChangePass(input) {
  return async (dispatch) => {
    
    console.log("The Input");
    console.log(input);
    dispatch(setChangePassLoading());
  

    console.log("data");

    var config = {
      method: 'get',
      url: `${updateUserURL()}?username=${input.authUser.username}&password=${encodeURIComponent(input.authUser.password)}&token=${input.authUser.token}&p=${input.p}`,
      headers: { 
        'Content-Type': 'application/json'
      }
    };

    //console.log(data);
    await axios(config).then(function (response) {
       
        //console.log("response.data");
        console.log(response.data);
        if(response.data.ID > 0 ){
          console.log("Success");
          dispatch(setChangePassResultBox({message : response.data.Message , type : 2}));
          
        }else{
          dispatch(setChangePassResultBox({message : response.data.Message , type : 1}));
        }

      }).catch(function (err) {
        dispatch(setChangePassResultBox({message : err.message , type : 1}));

      }).finally(()=> {
        dispatch(setChangePassLoadingFalse());
      });
  
  };
}


